import React, { ReactNode } from "react";
import Paper from "@mui/material/Paper";

type Props = {
  children: ReactNode;
};

const Main: React.FC<Props> = ({ children }) => {
  return (
    <Paper
      id="main-content"
      component="main"
      sx={{
        minHeight: "90vh",
        backgroundColor: "#ffffff",
      }}
    >
      {children}
    </Paper>
  );
};

export default Main;
